<template>
  <div class="main-out">
    <div class="header">
      <div class="header-content">
        <h1>Alle Aufträge</h1>
      </div>
      <div class="menue">
        <router-link :to="`/manage/mitarbeiter`" class="option" id="selected"
          >Aufträge</router-link
        >
        <router-link :to="`/manage/mitarbeitererledigt`" class="option"
          >Erledigt</router-link
        >
      </div>
      <input
        type="text"
        placeholder="Informationen eingeben"
        v-model="searchQuery"
        class="search-input"
      />
    </div>
    <div class="aufträge" @dragover.prevent @drop="handleDrop">
      <div v-for="(auftrag, index) in aufträge" :key="auftrag.id">
        <div
          v-if="index === 0 || auftrag.date !== aufträge[index - 1].date"
          class="date-separator"
        >
          <p class="date-separator-text">{{ formatDate(auftrag.date) }}</p>
        </div>

        <div
          :class="[
            'auftrag',
            { deleted: auftrag.deleted, completed: auftrag.completed },
          ]"
        >
          <div class="auftrag-content">
            <h1 class="auftrag-title">
              {{ auftrag.title }} - {{ auftrag.number }}
            </h1>
            <p class="address">
              {{ auftrag.address }} - {{ auftrag.customer }}
            </p>
            <p class="time">Vereinbart um: {{ auftrag.time }}</p>
            <div class="dauer">{{ auftrag.duration }}</div>
            <p class="email">E-Mail: {{ auftrag.email }}</p>
            <p class="phone">Telefon: {{ auftrag.phone }}</p>
            <p class="date">Datum: {{ formatDate(auftrag.date) }}</p>
            <p class="phone">Gehört zu: {{ auftrag.worker }}</p>
            <p class="phone">Materialien: {{ auftrag.materialien?.join(", ") || 'Keine Materialien' }}</p>

          </div>
          <div class="button-container">
            <button
              class="edit-btn"
              @click="openEditModal(auftrag)"
              v-if="!auftrag.deleted && !auftrag.completed"
            >
              Ändern
            </button>
            <button
              class="delete-btn"
              @click="toggleDelete(auftrag)"
              v-if="!auftrag.deleted && !auftrag.completed"
            >
              Löschen
            </button>
            <button
              class="restore-btn"
              @click="restoreAuftrag(auftrag)"
              v-if="auftrag.deleted"
            >
              Zurückholen
            </button>
            <button
              class="delete-btn"
              @click="deleteAuftrag(index)"
              v-if="auftrag.deleted"
            >
              Wirklich Löschen
            </button>
            <button
              class="complete-btn"
              @click="openCompleteModal(auftrag)"
              v-if="!auftrag.deleted && !auftrag.completed"
            >
              Erledigt
            </button>
            <button
              class="complete-btn"
              @click="openGoogleMaps(auftrag.address)"
              v-if="!auftrag.deleted && !auftrag.completed"
            >
              Route
            </button>
            <button
              class="remove-btn"
              @click="removeAuftrag(index)"
              v-if="auftrag.completed"
            >
              Abhaken
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="actions">
      <button class="add-btn" @click="showAddModal = true">
        Auftrag hinzufügen
      </button>
    </div>

    <!-- Modal für Auftrag hinzufügen -->
    <div
      v-if="showAddModal"
      class="modal-overlay"
      @click="showAddModal = false"
    >
      <div class="modal" @click.stop>
        <div class="auftragtext">
          <h2>Neuen Auftrag hinzufügen</h2>
          <!-- Auftrag Felder -->
          <label>
            Titel:
            <div class="identify">
              <input v-model="newAuftrag.title" class="title" type="text" />
              <input
                v-model="newAuftrag.number"
                class="idnumber"
                type="text"
                placeholder="Auftr. nummer"
              />
            </div>
          </label>
          <label>
            Adresse:
            <input v-model="newAuftrag.address" type="text" />
          </label>
          <label>
            Kunde:
            <input v-model="newAuftrag.customer" type="text" />
          </label>
          <label>
            Dauer:
            <input v-model="newAuftrag.duration" type="text" />
          </label>
          <label>
            Vereinbarte Uhrzeit:
            <input v-model="newAuftrag.time" type="time" />
          </label>
          <label>
            E-Mail-Adresse:
            <input v-model="newAuftrag.email" type="email" />
          </label>
          <label>
            Telefonnummer:
            <input v-model="newAuftrag.phone" type="tel" />
          </label>
          <label>
            Datum:
            <input v-model="newAuftrag.date" type="date" />
          </label>
          <div>
            <select v-model="newAuftrag.worker" class="selectmenue">
              <option
                v-for="worker in workers"
                :key="worker.id"
                :value="worker.username"
              >
                {{ worker.firstName }} {{ worker.lastName }}
              </option>
            </select>
          </div>
        </div>
        <div class="auftragsinfos">
          <!-- Materialauswahl hinzufügen -->

    

          <div class="modal-buttons">
            <button @click="addAuftrag">Hinzufügen</button>
            <button @click="showAddModal = false" class="cancel-btn">
              Abbrechen
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal für Auftrag ändern -->
    <div
      v-if="showEditModal"
      class="modal-overlay"
      @click="showEditModal = false"
    >
      <div class="modal" @click.stop>
        <div class="auftragtext">
          <h2>Auftrag ändern</h2>
          <!-- Auftrag Felder -->
          <label>
            Titel:
            <div class="identify">
              <input v-model="editAuftrag.title" class="title" type="text" />
              <input
                v-model="editAuftrag.number"
                class="idnumber"
                type="text"
                placeholder="Auftr. nummer"
              />
            </div>
          </label>
          <label>
            Adresse:
            <input v-model="editAuftrag.address" type="text" />
          </label>
          <label>
            Kunde:
            <input v-model="editAuftrag.customer" type="text" />
          </label>
          <label>
            Dauer:
            <input v-model="editAuftrag.duration" type="text" />
          </label>
          <label>
            Vereinbarte Uhrzeit:
            <input v-model="editAuftrag.time" type="time" />
          </label>
          <label>
            E-Mail-Adresse:
            <input v-model="editAuftrag.email" type="email" />
          </label>
          <label>
            Telefonnummer:
            <input v-model="editAuftrag.phone" type="tel" />
          </label>
          <label>
            Datum:
            <input v-model="editAuftrag.date" type="date" />
          </label>
          <div>
            <select v-model="editAuftrag.worker" class="selectmenue">
              <option
                v-for="worker in workers"
                :key="worker.id"
                :value="worker.username"
              >
                {{ worker.firstName }} {{ worker.lastName }}
              </option>
            </select>
          </div>
        </div>
        <div class="auftragsinfos">
          <!-- Materialauswahl hinzufügen -->
          <!-- Materialauswahl hinzufügen -->

      

          <div class="modal-buttons">
            <button @click="updateAuftrag">Ändern</button>
            <button @click="showEditModal = false" class="cancel-btn">
              Abbrechen
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal für Auftrag erledigt -->
    <div v-if="showCompleteModal" class="modal-overlay" @click="showCompleteModal = false">
      <div class="modal" @click.stop>
        <h2>Auftrag erledigt</h2>
        <label>
          Fehlerbehebung:
          <textarea v-model="completeTime.fehler" rows="4" placeholder="Fehlerbehebung"></textarea>
        </label>
        <label>
          Benötigte Materialien:
          <input v-model="materialSearchQuery" @input="searchMaterials" placeholder="Material suchen..." />
        </label>
        <div v-if="materialSearchResults.length">
          <h3>Suchergebnisse:</h3>
          <ul class="material-list">
            <li v-for="material in materialSearchResults" :key="material.id" :class="[
              'material-item',
              { selected: materialInSelection(material) },
            ]" @click="addMaterialToSelection(material)">
              <p class="options">
                {{ material.produktname }} - {{ material.preis }} €
              </p>
            </li>
          </ul>
        </div>

        <div class="selected-materials">
          <h3>Ausgewählte Materialien:</h3>
          <ul>
            <li v-for="(item, index) in selectedMaterials" :key="index">
              {{ item.material.produktname }} - {{ item.material.preis }} € - Menge: {{ item.quantity }}
              <button @click="changeMaterialQuantity(index, -1)" v-if="item.quantity > 1" class="mengebtn">-</button>
              <button @click="changeMaterialQuantity(index, 1)" class="mengebtn">+</button>
              <button @click="removeMaterial(index)" class="entfbtn">Entfernen</button>
            </li>
          </ul>
        </div>
        <label>
          Benötigte Zeit(inkl. Fahrzeit):
          <input v-model="completeTime.time" type="text" />
        </label>
        <label>
          Benötigte Zeit Werkstadt:
          <input v-model="completeTime.werkstadt" type="text" />
        </label>
        <label>
          Zone:
          <input v-model="completeTime.zone" type="number" />
        </label>
        <label>
          Bemerkungen (optional):
          <textarea v-model="completeTime.comments" rows="4" placeholder="Optionale Bemerkungen"></textarea>
        </label>

        <div class="modal-buttons">
          <button @click="completeAuftrag">Bestätigen</button>
          <button @click="showCompleteModal = false" class="cancel-btn">
            Abbrechen
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import axios from "axios";
import { keycloak, initKeycloak } from "../keycloak";

axios.defaults.withCredentials = true;

export default {
  setup() {
    const aufträge = ref([]);
    const searchQuery = ref("");
    const showAddModal = ref(false);
    const showEditModal = ref(false);
    const showCompleteModal = ref(false);
    const workers = ref([]);

    // Neue Variablen für Materialsuche und Auswahl
    const materialSearchQuery = ref("");
    const materialSearchResults = ref([]);
    const selectedMaterials = ref([]);


    axios.interceptors.request.use(
      (config) => {
        config.headers["Authorization"] = `Bearer ${keycloak.token}`;
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    const newAuftrag = ref({
      title: "",
      number: "",
      address: "",
      customer: "",
      duration: "",
      time: "",
      email: "",
      phone: "",
      date: "",
      worker: "",
      materials: [],
    });

    const editAuftrag = ref({
      id: null,
      title: "",
      number: "",
      address: "",
      customer: "",
      duration: "",
      time: "",
      email: "",
      phone: "",
      date: "",
      worker: "",
      materials: [],
    });

    const completeAuftragData = ref(null);

    const completeTime = ref({
      time: "",
      comments: "",
    });

    watch(searchQuery, (newValue) => {
      search(newValue);
    });

    const searchMaterials = async () => {
      if (materialSearchQuery.value.trim() !== "") {
        try {
          const response = await axios.get("/api/materials/search", {
            params: { query: materialSearchQuery.value },
          });
          materialSearchResults.value = response.data;
        } catch (error) {
          console.error("Fehler bei der Materialsuche:", error);
        }
      } else {
        materialSearchResults.value = [];
      }
    };

    const materialInSelection = (material) => {
      return selectedMaterials.value.some(
        (item) => item.material.id === material.id
      );
    };

    const changeMaterialQuantity = (index, delta) => {
      const item = selectedMaterials.value[index];
      item.quantity += delta;
      if (item.quantity <= 0) {
        selectedMaterials.value.splice(index, 1);
      }
    };


    const addMaterialToSelection = (material) => {
      const existingItem = selectedMaterials.value.find(
        (item) => item.material.id === material.id
      );
      if (existingItem) {
        existingItem.quantity++;
      } else {
        console.log('added' + material)
        selectedMaterials.value.push({ material, quantity: 1 });
      }
    };


    // Material zu einem Auftrag hinzufügen
    const addMaterialToAuftrag = (material) => {
      // Überprüfen, ob editAuftrag.value.materials existiert
      if (!editAuftrag.value.materials) {
        editAuftrag.value.materials = []; // Initialisiere, falls undefined
      }

      // Prüfe, ob das Material bereits hinzugefügt wurde (über die ID)
      const isMaterialAlreadyAdded = editAuftrag.value.materials.includes(
        material.id
      );

      if (!isMaterialAlreadyAdded) {
        // Füge das Material zur Liste der ausgewählten Materialien hinzu (für Anzeige)
        selectedMaterials.value.push(material);

        // Speichere die Material-ID im Auftrag (dies wird an den Server gesendet)
        editAuftrag.value.materials.push(material.id);
      }
    };

    const removeMaterial = (material) => {
      const index = selectedMaterials.value.findIndex(
        (m) => m.id === material.id
      );
      if (index !== -1) {
        selectedMaterials.value.splice(index, 1);
      }
    };

    const search = async (query) => {
      try {
        const response = await axios.post(`/api/alleauftaege/search`, {
          title: query,
        });
        aufträge.value = response.data;
        sortAufträge();
      } catch (error) {
        console.error("Error searching data:", error);
      }
    };

    const updateWorker = async (auftrag) => {
      try {
        await axios.post(`/api/auftraege/update`, {
          ...auftrag,
          worker: auftrag.worker,
        });
      } catch (error) {
        console.error("Error updating worker:", error);
      }
    };

    const fetchAufträge = async () => {
      try {
        const response = await axios.post(`/api/alleauftaege`);
        aufträge.value = response.data;
        sortAufträge();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchWorkers = async () => {
      try {
        const response = await axios.get(`/api/worker`);
        workers.value = response.data;
      } catch (error) {
        console.error("Error fetching workers:", error);
      }
    };

    onMounted(() => {
      fetchAufträge();
      fetchWorkers();
    });

    const openGoogleMaps = (address) => {
      const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        address
      )}`;
      window.open(url, "_blank");
    };

    const addAuftrag = async () => {
      const newOrder = {
        ...newAuftrag.value,
        deleted: false,
        completed: false,
        materials: selectedMaterials.value, // Materialien hinzufügen
      };
      try {
        const response = await axios.post(`/api/auftraege/add`, newOrder);
        fetchAufträge();
        aufträge.value.push({
          ...newAuftrag.value,
          deleted: false,
          completed: false,
        });
        newAuftrag.value = {
          title: "",
          address: "",
          customer: "",
          duration: "",
          time: "",
          email: "",
          phone: "",
          date: "",
          worker: "",
        };

        sortAufträge();
      } catch (error) {
        console.error("Fehler beim Absenden der Daten:", error);
      } finally {
        showAddModal.value = false;
      }
    };

    const openEditModal = (auftrag) => {
      editAuftrag.value = { ...auftrag };

      // Falls der Auftrag bereits Materialien hat, diese in die Liste übernehmen
      if (auftrag.materialien?.join(", ")) {
        selectedMaterials.value = [...auftrag.materialien?.join(", ")];
        console.log(selectedMaterials.value)
      } else {
        selectedMaterials.value = [];
      }

      // Materialien suchen
      searchMaterials();
      showEditModal.value = true;
    };

    const updateAuftrag = async () => {
      const index = aufträge.value.findIndex(
        (auftrag) => auftrag.id === editAuftrag.value.id
      );
      const edit = { ...editAuftrag.value };

      if (edit.date) {
        edit.date = new Date(edit.date).toISOString().split("T")[0];
      } else {
        edit.date = null;
      }

      if (index !== -1) {
        aufträge.value.splice(index, 1, { ...editAuftrag.value });
      }
      try {
        const response = await axios.post(`/api/auftraege/update`, edit, {
          params: { name: name.value },
        });
        "Aufträge erfolgreich gesendet:", response.data;
      } catch (error) {
        console.error("Fehler beim Absenden der Daten:", error);
      }
      showEditModal.value = false;
    };

    const toggleDelete = async (auftrag) => {
      try {
        auftrag.deleted = !auftrag.deleted;
        await axios.post(`/api/auftraege/aendern`, auftrag);
      } catch (error) {
        console.error(
          "Fehler beim Löschen/Wiederherstellen des Auftrags:",
          error
        );
      }
    };

    const restoreAuftrag = async (auftrag) => {
      auftrag.deleted = false;
      await toggleDelete(auftrag);
    };

    const deleteAuftrag = async (index) => {
      const auftragToDelete = aufträge.value[index];
      try {
        await axios.post(`/api/auftraege/delete`, { id: auftragToDelete.id });
      } catch (error) {
        console.error("Fehler beim endgültigen Löschen des Auftrags:", error);
      }
      aufträge.value.splice(index, 1);
    };

    const openCompleteModal = (auftrag) => {
      completeAuftragData.value = auftrag;
      showCompleteModal.value = true;
    };

    const removeAuftrag = async (index) => {
      aufträge.value.splice(index, 1);
    };

    const sortAufträge = () => {
      aufträge.value.sort((a, b) => new Date(a.date) - new Date(b.date));
    };

    const submitAufträge = async () => {
      try {
        await axios.post(`/api/auftraege`, aufträge.value);
      } catch (error) {
        console.error("Fehler beim Absenden der Daten:", error);
      }
    };

    const formatDate = (date) => {
      return new Date(date).toLocaleDateString();
    };


    const completeAuftrag = async () => {
  if (completeAuftragData.value) {
    // Datum formatieren
    completeAuftragData.value.date = formatToSQLDate(completeAuftragData.value.date);
    completeAuftragData.value.completed = true;

    // Materialien korrekt formatieren
    const formattedMaterials = selectedMaterials.value.map((item) => ({
      id: item.material.id,
      produktname: item.material.produktname,
      quantity: item.quantity,
      preis: item.material.preis,
    }));

    // Nur die relevanten Felder übernehmen
    const completionDetails = {
      time: completeTime.value.time,
      comments: completeTime.value.comments,
      fehler: completeTime.value.fehler,
      werkstadt: completeTime.value.werkstadt,
      zone: completeTime.value.zone,
      materials: formattedMaterials,
    };

    // Auftragsdaten aktualisieren, indem nur die benötigten Felder übernommen werden
    const updatedAuftrag = {
      id: completeAuftragData.value.id,
      title: completeAuftragData.value.title,
      address: completeAuftragData.value.address,
      customer: completeAuftragData.value.customer,
      time: completeAuftragData.value.time,
      date: completeAuftragData.value.date,
      duration: completeAuftragData.value.duration,
      email: completeAuftragData.value.email,
      phone: completeAuftragData.value.phone,
      completed: true,
      completionDetails,  // Nur relevante Daten werden hinzugefügt
    };

    // Modal schließen
    showCompleteModal.value = false;

    try {
      // Absenden des aktualisierten Auftrags
      await axios.post(`/api/auftraege/erledigt`, updatedAuftrag, {
        params: { name: name.value },
      });
    } catch (error) {
      console.error("Fehler beim Absenden der Daten:", error);
    }

    // Formularfelder zurücksetzen
    completeTime.value = { time: "", comments: "", fehler: "", werkstadt: "", zone: "" };
    selectedMaterials.value = [];
    materialSearchQuery.value = "";
    materialSearchResults.value = [];
  }
};

    const formatToSQLDate = (date) => {
      return new Date(date).toISOString().slice(0, 10);
    };
    

    return {
      changeMaterialQuantity,
      addMaterialToSelection,
      materialInSelection,
      removeMaterial,
      materialSearchQuery,
      materialSearchResults,
      selectedMaterials,
      searchMaterials,
      addMaterialToAuftrag,
      aufträge,
      searchQuery,
      showAddModal,
      showEditModal,
      showCompleteModal,
      newAuftrag,
      editAuftrag,
      completeAuftragData,
      completeTime,
      workers,
      search,
      fetchAufträge,
      addAuftrag,
      openEditModal,
      updateAuftrag,
      updateWorker,
      toggleDelete,
      restoreAuftrag,
      deleteAuftrag,
      openCompleteModal,
      completeAuftrag,
      removeAuftrag,
      submitAufträge,
      formatDate,
      openGoogleMaps,
    };
  },
};
</script>

<style scoped>
.entfbtn{
  background-color: #dc2626;
  padding: 5px 10px;
  border: none;
  outline: none;
  border-radius: 5px;
  margin-left: 5px;
}
.mengebtn{
  background-color: #059669;
  padding: 5px 10px;
  border: none;
  outline: none;
  border-radius: 5px;
  margin-left: 5px;
}
.material-list {
  margin: 10px 0;
  max-height: 150px;
  overflow-y: auto;
  border: 1px solid #374151;
  border-radius: 8px;
  background-color: #1f2937;
  padding: 10px;
  text-align: center;
}
.material-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  color: #d1d5db;
  background-color: #1f2937;
  border: 1px solid #374151;
  border-radius: 8px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: background-color 0.3s;
  text-align: center;
}

.material-item:hover {
  background-color: #374151;
}

.material-item.selected {
  background-color: #10b981;
}


.options {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}



.li {
  text-decoration: none;
  padding: 10px;
  border-radius: 5px;
  background-color: #374151;
  margin-top: 5px;
}
.add-material-btn,
.remove-material-btn {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 4px;
}

.add-material-btn:hover,
.remove-material-btn:hover {
  background-color: #0056b3;
}

.placeholder {
  height: 70px;
}
.title {
  width: 100% !important;
}
.idnumber {
  margin-left: 20px;
  width: 30% !important;
}
.identify {
  width: 102.5%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.selectmenue {
  background-color: #1f2937;
  border: 1px solid white;
  border-radius: 5px;
  color: white;
}
.date-separator {
  text-align: center;
  margin: 20px 0;
}

.date-separator-text {
  display: inline-block;
  padding: 5px 15px;
  width: 96%;
  border-radius: 5px;
  background-color: #374151;
  color: #f3f4f6;
  font-weight: bold;
}

/* Header-Stile */
.header {
  text-align: center;
  position: relative;
  width: 100%;
}

/* Flex-Container für Zurück-Button und Titel */
.header-content {
  display: flex;
  align-items: center;
  justify-content: center; /* Zentriert den Inhalt */
  gap: 20px;
}

.header h1 {
  font-size: 2rem;
  color: #f3f4f6; /* Heller Text */
  margin: 0; /* Entfernt den Standard-Abstand */
}

/* Zurück-Button-Stil */
.back-button {
  position: absolute;
  left: 0;
  padding: 10px 20px;
  border-radius: 8px;
  background-color: #1f2937; /* Dunklerer Hintergrund */
  text-decoration: none;
  color: #d1d5db; /* Heller Text */
  transition: background-color 0.3s;
}

.back-button:hover {
  background-color: #374151; /* Hellere Hover-Farbe */
}

/* Menü bleibt unverändert */
.menue {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 15px;
}

.back-button-container {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
}

.back-button {
  padding: 10px 20px;
  border-radius: 8px;
  background-color: #1f2937; /* Dunklerer Hintergrund */
  text-decoration: none;
  color: #d1d5db; /* Heller Text */
  transition: background-color 0.3s;
}

.back-button:hover {
  background-color: #374151; /* Hellere Hover-Farbe */
}

/* Haupt-Layout */
.main-out {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #111827; /* Dunkler Hintergrund */
  color: #d1d5db; /* Heller Text */
  font-family: "Inter", sans-serif;
  padding: 20px;
  box-sizing: border-box;
}

/* Header-Stile */
.header {
  text-align: center;
}

.header h1 {
  font-size: 2rem;
  color: #f3f4f6; /* Heller Text */
}

.menue {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 15px;
}

.option {
  padding: 10px 20px;
  border-radius: 8px;
  background-color: #1f2937; /* Dunklerer Hintergrund */
  text-decoration: none;
  color: #d1d5db; /* Heller Text */
  transition: background-color 0.3s;
}

.option:hover {
  background-color: #374151; /* Hellere Hover-Farbe */
}

#selected {
  outline: 2px solid #3b82f6; /* Blaue Umrandung */
}

/* Aufträge Container */
.aufträge {
  width: 100%;
  max-width: 800px; /* Größere Maximalbreite */
  margin-top: 20px;
  display: grid;
  grid-template-columns: 1fr; /* Einspaltiges Layout */
  gap: 15px;
}

/* Einzelne Aufträge */
.auftrag {
  background-color: #1f2937; /* Dunkler Hintergrund */
  border-radius: 8px;
  padding: 20px;
  transition: transform 0.3s, background-color 0.3s;
  cursor: pointer;
}

.auftrag:hover {
  transform: translateY(-3px);
  background-color: #374151; /* Hellere Hover-Farbe */
}

.auftrag.deleted {
  background-color: #dc2626; /* Rote Farbe für gelöschte Aufträge */
  opacity: 0.8;
}

.auftrag.completed {
  background-color: #10b981; /* Grüne Farbe für erledigte Aufträge */
  opacity: 0.8;
}

/* Auftrag Details */
.auftrag-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.auftrag-title {
  font-size: 1.5rem;
  font-weight: 600;
}

.address,
.time,
.dauer,
.email,
.phone,
.date {
  font-size: 1rem;
}

/* Schaltflächen Container */
.button-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

/* Schaltflächen */
button {
  padding: 8px 15px;
  border-radius: 5px;
  border: none;
  font-size: 1rem;
  color: white;
  cursor: pointer;
  transition: background-color 0.3s;
}

.edit-btn {
  background-color: #3b82f6; /* Blaue Farbe */
}

.edit-btn:hover {
  background-color: #2563eb; /* Dunklere blaue Farbe */
}

.delete-btn {
  background-color: #ef4444; /* Rote Farbe */
}

.delete-btn:hover {
  background-color: #dc2626; /* Dunklere rote Farbe */
}

.restore-btn {
  background-color: #10b981; /* Grüne Farbe */
}

.restore-btn:hover {
  background-color: #059669; /* Dunklere grüne Farbe */
}

.complete-btn {
  background-color: #10b981; /* Grüne Farbe */
}

.complete-btn:hover {
  background-color: #059669; /* Dunklere grüne Farbe */
}

.remove-btn {
  background-color: #6b7280; /* Graue Farbe */
}

.remove-btn:hover {
  background-color: #4b5563; /* Dunklere graue Farbe */
}

/* Modal Overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(
    0,
    0,
    0,
    0.6
  ); /* Halbtransparenter dunkler Hintergrund */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Modal Fenster */
.modal {
  background-color: #1f2937;
  padding: 30px;
  border-radius: 12px;
  width: 100%;
  max-width: 500px;
  max-height: 80vh;
  /* Maximale Höhe auf 80% des Viewports begrenzen */
  overflow-y: auto;
  /* Scrollbarkeit bei Überlauf */
}

.modal h2 {
  font-size: 1.75rem;
  margin-bottom: 20px;
  color: #f3f4f6; /* Heller Text */
}

.modal label {
  display: block;
  margin-bottom: 15px;
  color: #d1d5db; /* Heller Text */
}

.modal input,
.modal textarea {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #374151;
  background-color: #111827; /* Sehr dunkler Hintergrund */
  color: #f3f4f6; /* Heller Text */
  font-size: 1rem;
}

.modal-buttons {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

/* Modal Schaltflächen */
.modal-buttons button {
  padding: 10px 20px;
  border-radius: 5px;
  border: none;
  font-size: 1rem;
  color: white;
  cursor: pointer;
}

.modal-buttons button:first-child {
  background-color: #3b82f6; /* Blaue Farbe */
}

.modal-buttons button:first-child:hover {
  background-color: #2563eb; /* Dunklere blaue Farbe */
}

.cancel-btn {
  background-color: #6b7280; /* Graue Farbe */
}

.cancel-btn:hover {
  background-color: #4b5563; /* Dunklere graue Farbe */
}

/* Aktions-Schaltflächen */
.actions {
  position: fixed;
  bottom: 20px; /* Abstand vom unteren Rand des Bildschirms */
  left: 50%; /* Positionierung in der horizontalen Mitte des Bildschirms */
  transform: translateX(-50%); /* Zentrierung des Buttons */
  z-index: 1000; /* Über anderen Elementen anzeigen */
}

.add-btn {
  padding: 10px 20px;
  font-size: 1rem;
  background-color: #3b82f6;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.add-btn:hover {
  background-color: #2563eb;
}

/* Stil für das Input-Feld */
.search-input {
  margin-top: 20px;
  width: 100%;
  max-width: 400px;
  padding: 10px 15px;
  border-radius: 8px;
  border: 1px solid #374151; /* Dunkler Rand */
  background-color: #1f2937; /* Dunkler Hintergrund */
  color: #f3f4f6; /* Heller Text */
  font-size: 1rem;
  transition: border-color 0.3s;
  box-sizing: border-box;
}

.search-input::placeholder {
  color: #9ca3af; /* Hellere Farbe für Platzhaltertext */
}

.search-input:focus {
  outline: none;
  border-color: #3b82f6; /* Blaue Farbe bei Fokus */
}
/* Allgemeine Styles bleiben unverändert */

/* Mobile Optimierungen */
@media (max-width: 600px) {
  .auftrag {
    padding: 10px; /* Weniger Padding */
  }

  .auftrag-title {
    font-size: 1.2rem; /* Kleinere Schriftgröße für den Titel */
  }

  .address,
  .time,
  .dauer,
  .email,
  .phone,
  .date {
    font-size: 0.9rem; /* Kleinere Schriftgröße für die Details */
  }

  .auftrag-content {
    gap: 5px; /* Weniger Abstand zwischen den Elementen */
  }

  .button-container {
    flex-direction: column; /* Buttons untereinander anordnen */
    gap: 5px; /* Weniger Abstand zwischen den Buttons */
  }

  button {
    padding: 5px 10px; /* Kleinere Buttons */
    font-size: 0.9rem; /* Kleinere Schriftgröße für Buttons */
  }

  .date-separator-text {
    padding: 5px 10px;
    width: 95%; /* Weniger Breite, damit es nicht am Rand abschneidet */
  }
}
</style>
